import React from 'react'

const stepIcons = {
  store: 'fa-store',
  service: 'fa-coin-front',
  employee: 'fa-user',
  timeSlot: 'fa-clock'
}

export default function Step({
  title, stepKey, currentStep, setCurrentStep, steps, value, isLast, children
}) {
  const isCurrentStep = currentStep === stepKey
  const stepIndex = steps.findIndex( step => step === stepKey )
  const currentStepIndex = steps.findIndex( step => step === currentStep )
  const isPreviousStep = currentStepIndex > stepIndex
  const isNextStep = !isPreviousStep && !isCurrentStep

  return (
    <>
      <div
        className={ `option-header flex-box content-space-between ${ isPreviousStep ? 'selectable' : '' }` }
        onClick={ () => isPreviousStep && setCurrentStep(stepKey) }
      >
        <div className='flex-box items-center'>
          <i className={ `option-icon fal ${ stepIcons[stepKey] }` }/>

          <div className='option-title'>
            { title }
          </div>
        </div>

        { value &&
          <div className={ `option-value ${ isNextStep || isCurrentStep ? 'disabled' : '' }` }>
            { value }
          </div>
        }
      </div>

      { isCurrentStep && children }

      { !isLast &&
        <div className='divider'/>
      }
    </>
  )
}
